import { API_ENDPOINTS } from "../config/apiConfig";
import { authenticatedFetch } from "../utils/api";

const PAGE_LOAD_BY_PATH = {
  "/": "karma-home",
  "/graph": "karma-domain",
  "/karma-pulse": "karma-pulse",
  "/admin": "admin",
};

export function resolvePageLoadPage(pathname) {
  if (pathname === "/compact-graph" || pathname.startsWith("/compact-graph/"))
    return "compact-graph";
  return PAGE_LOAD_BY_PATH[pathname] ?? null;
}

export async function reportPageLoad({ page, pageLoadId }) {
  await authenticatedFetch(API_ENDPOINTS.pageLoadAction(), {
    method: "POST",
    credentials: "include",
    skipOkCheck: true,
    body: JSON.stringify({
      page,
      page_load_id: pageLoadId,
    }),
  });
}
